module.exports = __webpack_public_path__ + "img/image12.18b8b755.png";